@let _onboardingStage = onboardingStage();
@let _deviceModel = data.deviceModel();
@let _activeStep = onboardingService.activeStep();

<sh-draggable-dialog-new
	*transloco="let t; prefix: 'scCoverage3dOnboarding'"
	[title]="
		_activeStep
			? (_activeStep | onboardingStepTitle: _deviceModel)
			: (_onboardingStage | onboardingStageTitle: _deviceModel)
	"
	[dialogCloseHandler]="this"
>
	@if (_onboardingStage !== onboardingStageEnum.InProgress) {
		<p>{{ _onboardingStage | onboardingStageDescription: _deviceModel }}</p>
	} @else {
		<prism-stepper #stepper (activeStepChange)="onActiveStepChange($event)" linear>
			@let _onboardingSteps = onboardingSteps();

			@for (step of _onboardingSteps; track step; let idx = $index) {
				<prism-step [label]="step.name | onboardingStepTitle: _deviceModel">
					<p>{{ step.name | onboardingStepDescription: _deviceModel }}</p>

					<div class="actions-container">
						@for (action of activeStepActions(); track action.action) {
							<prism-card [class.sh-good]="action.completed">
								<span>{{ action.action | onboardingActionDescription: _deviceModel }} </span>
								<prism-icon
									[icon]="action.completed ? 'check_circle' : 'radio_button_unchecked'"
									size="lg"
								></prism-icon>
							</prism-card>
						}
					</div>
				</prism-step>
			}
		</prism-stepper>
	}
	<div class="dialog-footer">
		<div class="dialog-footer-start">
			@switch (_onboardingStage) {
				@case (onboardingStageEnum.Introduction) {
					@if (data.doNotShowDialogId) {
						<sh-do-not-show-again-checkbox [(checked)]="doNotShowAgain"></sh-do-not-show-again-checkbox>
					}
				}
				@case (onboardingStageEnum.InProgress) {
					<prism-button (click)="onCloseDialog()">{{ t('onboarding-controls.skip-tutorial') }}</prism-button>
				}
			}
		</div>
		<div class="dialog-footer-end">
			@switch (_onboardingStage) {
				@case (onboardingStageEnum.Introduction) {
					<prism-button (click)="onIncrementStep()">{{
						t('onboarding-controls.show-tutorial')
					}}</prism-button>
				}
				@case (onboardingStageEnum.InProgress) {
					<prism-button (click)="onDecrementStep()">{{ t('onboarding-controls.previous') }}</prism-button>
					<prism-button (click)="onIncrementStep()" [disabled]="!activeStepActionsCompleted()">
						{{ t('onboarding-controls.next') }}
					</prism-button>
				}
				@case (onboardingStageEnum.Completed) {
					<prism-button (click)="onCloseDialog()">{{ t('onboarding-controls.end-tutorial') }}</prism-button>
				}
			}
		</div>
	</div>
</sh-draggable-dialog-new>
